'use client'

import { useEffect, useState } from 'react'

import { useTranslations } from 'next-intl'

export default function LbvFormContact() {
  const t = useTranslations('Contact')

  const [form, setForm] = useState({ name: '', email: '', message: '' })
  const [status, setStatus] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}`
    script.async = true
    document.body.appendChild(script)
  }, [])

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => setForm({ ...form, [e.target.name]: e.target.value })

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    setLoading(true)

    // @ts-ignore
    grecaptcha.enterprise.ready(async () => {
      // @ts-ignore
      const token = await grecaptcha.enterprise.execute(
        process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY,
        { action: 'LOGIN' }
      )

      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, captcha: token }),
      })

      const data = await res.json()
      setLoading(false)
      setStatus(data.message)
      if (res.ok) setForm({ name: '', email: '', message: '' })
    })
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="mx-auto max-w-lg space-y-4 rounded-lg border p-6 shadow"
    >
      <h2 className="font-bebasNeue-regular text-2xl">{t('contactForm')}</h2>

      <input
        type="text"
        name="name"
        placeholder={t('name')}
        value={form.name}
        onChange={handleChange}
        required
        className="w-full rounded border p-2"
      />

      <input
        type="email"
        name="email"
        placeholder="Email"
        value={form.email}
        onChange={handleChange}
        required
        className="w-full rounded border p-2"
      />

      <textarea
        name="message"
        placeholder="Message"
        rows={5}
        value={form.message}
        onChange={handleChange}
        required
        className="w-full rounded border p-2"
      />

      <button
        type="submit"
        disabled={loading}
        className="w-full rounded bg-green py-2 text-white duration-150 ease-in-out hover:bg-green/80"
      >
        {loading ? 'Envoi en cours...' : 'Envoyer'}
      </button>

      {status && <p className="mt-2 text-sm">{status}</p>}
    </form>
  )
}
